import { action, computed, observable } from 'mobx';

import { MenuRoutes, menuRoutes } from '@/constants/menu';

export default class MenuStore {
  @observable private accessor visible: boolean = true;

  @action.bound public setVisible(value: boolean) {
    this.visible = value;
  }

  @computed public get isVisible() {
    return this.visible;
  }

  @action.bound public switch(path: MenuRoutes) {
    this.setVisible(menuRoutes.includes(path));
  }
}
